import styled from 'styled-components';

export const ModalBodyWrapper = styled.div`
  padding: 20px;
  padding-top: 0;
  font-family: 'Graphik', helvetica;
  display: flex;
  flex-direction: column;
`;

ModalBodyWrapper.displayName = 'ModalBodyWrapper';

export const Message = styled.p`
  font-size: 14px;
  color: #003d50;
  padding-top: 10px;
  padding-bottom: 10px;
`;

Message.displayName = 'Message';

export const ButtonGroupWrapper = styled.div`
  align-self: flex-end;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  padding: 8px;
`;

ButtonGroupWrapper.displayName = 'ButtonGroupWrapper';

export const ButtonWrapper = styled.div`
  padding: 8px;
`;

ButtonWrapper.displayName = 'ButtonWrapper';

export const SpanColor = styled.span`
  color: #20907F;
`;

ButtonWrapper.displayName = 'ButtonWrapper';


export const CancelButton = styled.button`
  background-color: #fff;
  border-radius: 18px;
  border: 1px solid #20907F;
  color: #20907F;
  font-size: 13px;
  font-weight: bold;
  min-height: 38px;
  min-width: 94px;
  cursor: pointer;
  &:hover {
    background: #F2F2F2;
  }
`;
